import { render, staticRenderFns } from "./Follow-Up.vue?vue&type=template&id=8b9c2560"
import script from "./Follow-Up.vue?vue&type=script&lang=js"
export * from "./Follow-Up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports